import React from 'react'
import {
    Button,
    Divider,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalOverlay,
    SimpleGrid,
    Text,
    useDisclosure,
    useStyleConfig,
} from '@chakra-ui/react'

import {FormattedMessage} from 'react-intl'
import {useCompare} from '../../context/compare'
import CompareModalTiles from './compare-modal-tiles'
import {remCalc} from '../../theme/_utils'
import CompareTables from './compare-tables'
import {useGoogleTagManager} from '../../custom-api/hooks/use-google-tag-manager'
import {basic_gtm_event} from '../../custom-api/layers/default'

const CompareModal = () => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {addLayer} = useGoogleTagManager()

    const {
        clearItems,
        state: {compareItems},
    } = useCompare()

    const styles = useStyleConfig('ProductComparePlp')

    const handleCompareButtonClick = async () => {
        onOpen()
        await addLayer(
            basic_gtm_event.bind(this, {
                event: 'comparisonTool',
                eventCategory: 'ecommerce',
                eventAction: 'comparisonToolListing',
                eventLabel: 'tabLoaded',
            }),
        )
    }

    return (
        <>
            <SimpleGrid {...styles.bannerButtonGroup}>
                {compareItems.length === 1 && (
                    <Text {...styles.bannerSelectMore}>
                        <FormattedMessage
                            id="product_list.select_more_items"
                            defaultMessage="Choose 2 to 3 items to compare"
                        />
                    </Text>
                )}
                <Button
                    isDisabled={compareItems.length === 1}
                    data-cs-label="plp-compareButton"
                    onClick={handleCompareButtonClick}
                    variant="primary"
                >
                    <FormattedMessage
                        id="product_list.compare_button.compare"
                        defaultMessage="Compare"
                    />
                </Button>
                <Button
                    onClick={() => clearItems()}
                    variant="text-button"
                    {...styles.bannerRemoveItems}
                >
                    <FormattedMessage
                        id="product_list.compare_button.clear_all"
                        defaultMessage="Remove items"
                    />
                </Button>
            </SimpleGrid>
            <Modal onClose={onClose} size="full" isOpen={isOpen}>
                <ModalOverlay />
                <ModalContent>
                    <ModalBody {...styles.modal}>
                        <SimpleGrid {...styles.modalBody}>
                            <CompareModalTiles />
                            <Divider my={remCalc(20)} />
                            <CompareTables />
                        </SimpleGrid>
                    </ModalBody>
                    <ModalFooter />
                </ModalContent>
            </Modal>
        </>
    )
}

export default CompareModal
